import { FC, memo } from 'react'

import { UploadFile } from 'types'
import UploadContent from './Content'
import UploadManagerProvider from './contexts/UploadManager/Provider'

export type UploadFileValidators = {
  acceptFileExtension?: string[]
  acceptFileSize?: number
}

export type UploadProps = UploadFileValidators & {
  isDisabled?: boolean
  onUpload: (file: UploadFile) => Promise<void>
}

const Upload: FC<UploadProps> = (props) => {
  return (
    <UploadManagerProvider onUpload={props.onUpload}>
      <UploadContent {...props} />
    </UploadManagerProvider>
  )
}

export default memo(Upload)
